export const ADD_WAREHOUSE_SUCCESS = "logistics/ADD_WAREHOUSE_SUCCESS";
export const ADD_WAREHOUSE_FAILURE = "logistics/ADD_WAREHOUSE_FAILURE";
export const GET_SINGLE_WAREHOUSE_SUCCESS = "logistics/GET_SINGLE_WAREHOUSE_SUCCESS";
export const GET_SINGLE_WAREHOUSE_FAILURE = "logistics/GET_SINGLE_WAREHOUSE_FAILURE";
export const GET_ALL_WAREHOUSE_SUCCESS = "logistics/GET_ALL_WAREHOUSE_SUCCESS";
export const GET_ALL_WAREHOUSE_FAILURE = "logistics/GET_ALL_WAREHOUSE_FAILURE";
